import { AvailabilityStates } from '@coolblue-development/next-availability-state';
import type { Product } from '@features/product/typings';
import { MainProduct } from '@features/second-chance/typings';

import { ActiveMailerButton } from '../ActiveMailerButton';
import { AddToCartContainer, ATCButtonVariation } from '../AddToCart';
import { WishlistButton } from '../WishlistButton';

type OrderButtonProps = {
  isLoading?: boolean;
  product: Product | MainProduct;
  privacyPolicyUrl: string;
  feature: 'order_block' | 'sticky_header' | 'order_summary';
  disabled: boolean;
  showWishlistButton?: boolean;
  isInSinterklaasSplitTest?: boolean;
  isCrossSellOnly?: boolean;
  isSecondChance?: boolean;
  customerEmailAddress?: string;
  formId?: string;
  variation?: ATCButtonVariation;
};

export default function OrderButton({
  isLoading,
  product,
  privacyPolicyUrl,
  feature,
  disabled,
  showWishlistButton = false,
  isInSinterklaasSplitTest = false,
  isCrossSellOnly = false,
  isSecondChance = false,
  customerEmailAddress,
  formId,
  variation = 'default'
}: OrderButtonProps) {
  const addToCartButton = (
    <>
      <AddToCartContainer
        productId={product.id}
        isLoading={isLoading}
        disabled={disabled}
        formId={formId}
        variation={variation}
      />
      {showWishlistButton && (
        <WishlistButton
          productId={product.id}
          feature={feature}
          isInSinterklaasSplitTest={isInSinterklaasSplitTest}
        />
      )}
    </>
  );

  if (isSecondChance) {
    return addToCartButton;
  } else {
    switch (product.availabilityState) {
      case AvailabilityStates.AvailableSoon:
      case AvailabilityStates.TemporaryOutOfStock:
        return (
          <>
            <ActiveMailerButton
              product={product}
              privacyPolicyUrl={privacyPolicyUrl}
              feature={feature === 'order_summary' ? 'bottom_product_card' : 'order_block'}
              customerEmailAddress={customerEmailAddress}
            />
            {showWishlistButton && (
              <WishlistButton
                productId={product.id}
                feature={feature}
                isInSinterklaasSplitTest={isInSinterklaasSplitTest}
              />
            )}
          </>
        );

      case AvailabilityStates.OnStock:
      case AvailabilityStates.PreOrder:
        if (isCrossSellOnly) {
          return (
            <ActiveMailerButton
              product={product}
              privacyPolicyUrl={privacyPolicyUrl}
              feature={feature === 'order_summary' ? 'bottom_product_card' : 'order_block'}
              customerEmailAddress={customerEmailAddress}
            />
          );
        }

        return addToCartButton;

      default:
        return null;
    }
  }
}
